import { API } from "aws-amplify";
import { createMoveExam } from "~/graphql/mutations";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

const EMPTY_MOVE_EXAM: APITypes.MoveExam = {
  id: "",
  status: APITypes.MoveExamStatusType.Pending,
  startDate: "",
  endDate: "",
  type: APITypes.MoveExamType.IN,
  __typename: "MoveExam",
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const addMoveExam = async (
  startDate: string,
  type: APITypes.MoveExamType
): Promise<LoaderData<APITypes.MoveExam>> => {
  try {
    const newMoveExam = await API.graphql({
      query: createMoveExam,
      variables: {
        input: {
          startDate: startDate,
          status: APITypes.MoveExamStatusType.Pending,
          type: type,
        },
      },
    });
    return {
      success: true,
      //@ts-ignore
      data: newMoveExam.data.createMoveExam,
    };
  } catch (error) {
    console.error("error adding move exam", error);
    return {
      success: false,
      data: EMPTY_MOVE_EXAM,
      error,
    };
  }
};
